import React from 'react'

import {AddUser_Manager} from "../../model/manager"
import UserToAdd from "../../model/add-user"
import CheckBox, {CheckboxType} from "../../../../gd-components/checkbox/checkbox"
import UserIcon from "../../../../gd-ui/icon/user/user"
import FieldFormElementView from "../../../../fields3/render/form-elemnent-view"
import {ProjectAccess} from "../../../../gd/const/project"
import FieldProjectAccess from "../../../../fields3/system/project/access/project-access"
import {ProjectAccessMode} from "../../../../model2/project/types"

type Props = {
    className?  : string

    manager     : AddUser_Manager
}

export default function ModalAddUser_AddToProject(props: Props) {

    const isMultiselectEnabled = props.manager.multiselect

    const toggleUser = (userToAdd:UserToAdd) => {
        if (!isMultiselectEnabled) {
            props.manager.unselectAll()
        }

        userToAdd.toggleIsSelected()
        props.manager.reRender()
    }

    const onAccessChange = (userToAdd:UserToAdd, access:ProjectAccess) => {
        userToAdd.projectAccess = access
        props.manager.reRender()
    }

    const classes = Classes("ui5-tabled-dashed w-100p", props.className)

    return (
        <>
            <div className={classes}>
                <div className="table-header">
                    <div className="cell flex-1">
                        <div className="ui5-title-small">
                            Workspace Users
                        </div>
                    </div>
                    <div className="cell w-160">
                        {props.manager.workspaceUsersToAdd.atLeastOneChecked &&
                            <div className="ui5-grid-header">
                                Project Access
                            </div>}
                    </div>
                </div>

                {_.isEmpty(props.manager.workspaceUsersToAdd.available) &&
                    <div className="table-row">
                        <div className="flex-row-center-center ui5-txt-not-important">
                            No users found
                        </div>
                    </div>}

                {_.map(props.manager.workspaceUsersToAdd.available, (userToAdd:UserToAdd, key:number)=>{
                    const rowClasses = Classes("table-row", {
                        'ui5-bg-gray'   : userToAdd.isSelected,
                        'p-l-5'         : !isMultiselectEnabled
                    })

                    const projectAccessField = _.cloneDeep(props.manager.projectAccessField) as FieldProjectAccess
                    // project access can't be lower than workspace access in INHERITANCE_CHILDREN
                    if (props.manager.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN) {
                        projectAccessField.minAccess = userToAdd.workspaceAccess
                    }

                    return (
                        <div className={rowClasses} key={key} onClick={toggleUser.bind(null, userToAdd)}>
                            <div className="cell flex-1 flex-row-left-center">
                                {isMultiselectEnabled &&
                                    <CheckBox className = "m-r-10 m-l-5"
                                              type      = {CheckboxType.FILLED}
                                              isChecked = {userToAdd.isSelected} />}
                                <UserIcon size="22" userId={userToAdd.id} className="m-r-8" />
                                <div className="ui5-txt-default">{userToAdd.user.name}</div>
                            </div>

                            <div className="cell w-160">
                                {userToAdd.isSelected &&
                                    <FieldFormElementView className = "w-140"
                                                          field     = {projectAccessField}
                                                          options   = {{size: '30'}}
                                                          model     = {userToAdd}
                                                          onChange  = {onAccessChange.bind(null, userToAdd)} />}
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
